import React, { useCallback } from "react";
import OtpInput from "react-otp-input";
import { OTP_LENGTH } from "../../constants/common";

interface CustomOtpInputProps {
  value: string;
  onChange: (otp: string) => void;
}

const CustomOtpInput: React.FC<CustomOtpInputProps> = ({ value, onChange }) => {
  const handleChange = useCallback(
    (otp: string) => {
      const isValid = /^[a-zA-Z0-9]*$/.test(otp);
      if (isValid) {
        onChange(otp);
      }
    },
    [onChange]
  );

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      const key = e.key;
      if (key.length === 1 && !/^[a-zA-Z0-9]$/.test(key)) {
        e.preventDefault();
      }
    },
    []
  );

  return (
    <OtpInput
      value={value}
      onChange={handleChange}
      numInputs={OTP_LENGTH}
      shouldAutoFocus
      skipDefaultStyles
      renderInput={(props) => (
        <input
          {...props}
          onKeyDown={(e) => {
            handleKeyDown(e);
            props.onKeyDown?.(e);
          }}
          className="mr-1 sm:mr-2.5 text-lg border border-gray-300 rounded-md text-center w-10 h-10"
        />
      )}
    />
  );
};

export default React.memo(CustomOtpInput);
